var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c('config-form-builder'):_c('loading'),_c('unsaved-checker',{ref:"unsavedChecker",attrs:{"has-unsaved-changes":_vm.hasUnsavedChanges,"skip-before-unload":_vm.skipBeforeUnload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }